export default "__VITE_ASSET__BYTv_nxF__"